// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1AXwQ","range":"MonthRangeSwitch_range__3q6TI","disabled":"MonthRangeSwitch_disabled__3FMbk"};